module.exports = __webpack_public_path__ + "img/bd3a7c8.png";